<template>
  <v-layout row wrap>
    <v-flex xs12>
      <connection-manager ref="connectionManager"/>
      <full-calendar :events="appointments" :config="config" @event-selected="onEventClicked"></full-calendar>
    </v-flex>

    <v-dialog v-model="showAppointmentDialog" max-width="600px" persistent>
      <v-card>
        <v-card-text :style="'max-height: '+cardHeight" class="scroll-y pa-3" v-if="selectedAppointment">
          <h2>{{ selectedAppointment.title }}</h2>
          <h5>{{ selectedAppointment.venue }}</h5>
          <v-chip label small color="accent" text-color="white">
            <v-icon left>access_time</v-icon>
            {{selectedAppointment.allDay ? 'All day'
            : selectedAppointment.startingAt+' -'+selectedAppointment.endingAt}}
          </v-chip>
          <v-divider></v-divider>
          <v-subheader>Internal Participants</v-subheader>
          <v-list avatar>
            <v-list-tile v-for="participant in selectedAppointment.internalParticipants" :key="participant.id">
              <v-list-tile-action>
                <v-icon color="primary">person</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ participant.name }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ participant.email }}</v-list-tile-sub-title>
                <v-list-tile-sub-title>{{participant.phone}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-subheader>External Participants</v-subheader>
          <v-list avatar>
            <v-list-tile v-for="participant in selectedAppointment.externalParticipants" :key="participant.id">
              <v-list-tile-action>
                <v-icon color="primary">person</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ participant.email }}</v-list-tile-title>
                <v-list-tile-sub-title>{{participant.phone}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-subheader>Issues/Items</v-subheader>
          <template v-for="(issue, index) in selectedAppointment.items">
            <p :key="issue.id">{{issue.details}}</p>
            <v-divider v-if="index !== selectedAppointment.items.length - 1" :key="'div_'+issue.id" class="mb-3"></v-divider>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click.native="showAppointmentDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <add-appointment-dialog :show="addingAppointment"
                            @onClose="onCloseDialog">
    </add-appointment-dialog>

    <v-fab-transition>
      <v-btn style="margin-bottom: 100px"
             color="accent"
             fab
             dark
             fixed
             bottom
             @click.native="addingAppointment = true"
             right>
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>

  </v-layout>
</template>

<script>
  import Moment from 'moment'
  import Base from './Base.vue'
  import {extendMoment} from 'moment-range'
  import ConnectionManager from './ConnectionManager'
  import AddAppointmentDialog from './AddAppointmentDialog'

  const moment = extendMoment(Moment)

  export default {
    extends: Base,
    components: {
      AddAppointmentDialog,
      ConnectionManager
    },
    name: 'appointments',
    data () {
      return {
        date: null,
        addingAppointment: false,
        appointments: [],
        showAppointmentDialog: false,
        selectedAppointment: null,
        config: {
          defaultView: 'month'
        }
      }
    },
    watch: {
      date (val) {
        this.refresh()
      }
    },
    methods: {
      onEventClicked (event) {
        this.$app.log(event)
        this.selectedAppointment = event
        this.showAppointmentDialog = true
      },
      refresh () {
        this.appointments = []
        let that = this
        this.$refs.connectionManager.get('appointments/allAppointments', {
          onSuccess (response) {
            that.appointments = []
            for (let appointment of response.data.data) {
              appointment.start = appointment.startingAt
              appointment.end = appointment.endingAt
              // appointment.active = false
              // that.appointmentDates.push(appointment.startingAt)
              that.appointments.push(appointment)
            }
          }
        }, {
          date: this.date
        })
      },
      onCloseDialog (addedAppointmentSuccessfully) {
        this.addingAppointment = false
        this.$app.log('addedAppointmentSuccessfully: ' + addedAppointmentSuccessfully)
        if (addedAppointmentSuccessfully) {
          this.refresh()
        }
      }
    },
    computed: {
      cardHeight () {
        return (this.$vuetify.breakpoint.height * 0.75) + 'px'
      }
    },
    mounted () {
      this.date = moment().format('YYYY-MM-DD')
      this.refresh()
    }
  }
</script>

<style scoped>
  @import '~fullcalendar/dist/fullcalendar.css';
</style>



// WEBPACK FOOTER //
// src/components/Appointments.vue